import React, { useContext } from "react";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const ProcessLevelBar = ({ level }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { registration } = adminRegistrationContext;
  const { orientationScheduled } = registration;

  return (
    <div id="progress-level-bar" className="level-bar">
      <ul className="step-menu">
        <li role="button" className={level === 0 ? "current" : "complete"}>
          Student Match Check
        </li>
        <li
          role="button"
          className={level === 1 ? "current" : level > 1 ? "complete" : ""}
        >
          {orientationScheduled ? "Confirm" : "Schedule"} Orientation
        </li>
        {/* <li
          role="button"
          className={level === 2 ? "current" : level > 2 ? "complete" : ""}
        >
          Add Special Programs
        </li> */}
      </ul>
    </div>
  );
};

export default ProcessLevelBar;
